import { ReactNode } from "react";
import { InteractiveContainer, Tooltip } from "@jugl-web/ui-components";
import { useTheme } from "@web-src/themes/useTheme";

export const SidebarLinkButton = ({
  text,
  icon,
  startSlot,
  isActive,
  tooltip,
  isSidebarExpanded,
  className,
  onClick,
}: {
  text: ReactNode;
  icon: ReactNode;
  startSlot?: ReactNode;
  isActive?: boolean;
  tooltip?: ReactNode;
  isSidebarExpanded?: boolean;
  className?: string;
  onClick?: () => void;
}) => {
  const { tcx } = useTheme();

  return (
    <Tooltip
      isDisabled={isSidebarExpanded || !tooltip}
      placement="right"
      renderTrigger={({ props, ref }) => (
        <InteractiveContainer {...props} onClick={onClick} ref={ref}>
          <div
            className={tcx(
              "font-secondary flex h-[41px] items-center gap-2 rounded-lg px-2.5 text-sm font-medium text-white",
              {
                light: [
                  "text-dark-800 hover:bg-[#ECF5FC]",
                  {
                    "bg-primary-50 text-[#133C84]": isActive,
                  },
                ],
                dark: [
                  "hover:bg-[#3E3F40]",
                  {
                    "bg-[#4D4D4D]": isActive,
                  },
                ],
                blue: [
                  "hover:bg-[#2F7DDA]",
                  {
                    "bg-primary-800": isActive,
                  },
                ],
              },
              isActive ? "font-semibold" : "",
              isSidebarExpanded
                ? "w-[190px]"
                : "w-[60px] flex-col justify-center text-center",
              className
            )}
          >
            {isSidebarExpanded && (
              <div
                title={text?.toString()}
                className="flex h-full w-full items-center gap-2 pr-2"
              >
                {startSlot}
                <span className="w-3/4 truncate">{text}</span>
              </div>
            )}

            <div className="flex h-full items-center justify-center transition-opacity duration-200">
              {icon}
            </div>
          </div>
        </InteractiveContainer>
      )}
    >
      {tooltip}
    </Tooltip>
  );
};
